const ReturnPolicy = () => {
  return (
    <div className="max-w-5xl mx-auto px-6 py-20 mt-10">
      
      <h1 className="text-3xl md:text-4xl font-semibold mb-8 text-center">
        Return & Refund Policy
      </h1>

      <div className="space-y-6 text-gray-700 leading-relaxed">

        <p>
          We want you to love what you purchase from us. If you are not
          completely satisfied, you may request a return under the conditions below.
        </p>

        <div>
          <h2 className="text-xl font-medium mb-2">1. Return Eligibility</h2>
          <ul className="list-disc ml-6 space-y-2">
            <li>Items must be returned within 7 days of delivery.</li>
            <li>Product must be unused and in original packaging.</li>
            <li>Items purchased on sale are not eligible for return.</li>
          </ul>
        </div>

        <div>
          <h2 className="text-xl font-medium mb-2">2. Refund Process</h2>
          <p>
            Once we receive and inspect your return, we will notify you about
            the approval or rejection of your refund.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-medium mb-2">3. Exchange Policy</h2>
          <p>
            We only replace items if they are defective or damaged.
            For exchange requests, please contact us on WhatsApp.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-medium mb-2">4. Contact Us</h2>
          <p>
            For any return or refund queries, please contact us via WhatsApp or email.
          </p>
        </div>

      </div>
    </div>
  );
};

export default ReturnPolicy;